// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--IJ2rm","pin":"_2787e5dfdf--pin--gSvAB","slidein":"_2787e5dfdf--slidein--ZrESf","label":"_2787e5dfdf--label--G_Bno"};